<template>
  <pro-input
    :label="label"
    :required="required"
    :message="message"
    :info="info"
    :icon="icon"
  >
    <input
      :id="id"
      ref="input"
      v-model="model"
      type="email"
      :name="name"
      class="form-control"
      :class="{'disabled': isLoading()}"
      :disabled="disabled"
      :autocomplete="autocomplete"
    >
  </pro-input>
</template>

<script>
import proInput from '@/mixins/proInput.js';

export default {
  name: 'ProEmail',
  mixins: [proInput],

  props: {
    domains: Array,
    multiple: Boolean,
  },

  methods: {
    /**
      * @OVERRIDE
      * Sobrescrita do method _isValid de proInput
     */
    _isValid(val) {
      if (!_.isUndefined(this.required) && val.length <= 0)
        return this.updateMessage('Este campo é obrigatório!');

      if (val.length <= 0)
        return this.updateMessage();

      if (!_.isUndefined(this.min) && val.length < this.min)
        return this.updateMessage(`Este campo precisa ter no mínimo ${this.min} dígitos!`);

      if (this.multiple ? !this.$utils.validator.validateMultipleEmails(val) : !this.$utils.validator.isEmail(val))
        return this.updateMessage('Informe um email válido.');

      if (!_.isUndefined(this.domains) && !_.isEmpty(this.domains)) {
        if (!this.domains.find(i => i === val.split('@')[1]))
          return this.updateMessage(`Utilize um dos domínios a seguir: ${this.domains.map((i, index) => `${(index !== this.domains.length - 1) ? `${i},` : `${i}.`} `).join('')}`);
      }

      return this.updateMessage();
    },

  },
};
</script>

<style lang="scss">

</style>
